import defaultColor from "@/components/color";
export default {
    attribute:{
        label:'显示位置:',
        url: '',
        size:'medium',
        strokeColor:'red',
        strokeWeight:3,
        strokeStyle: 'dashed', // solid或dashed
        duration:20000,
        showLable:true,
        cptTableData:[
        { "name": "经度", "value": "", "namekey": "LNG" },
        { "name": "纬度", "value": "", "namekey": "LAT" },
        // { "name": "图片", "value": "", "namekey": "url" }
       ],
        bgColor: defaultColor[0],
        textColor: '#fff',
        radius: 6,
        zoom:17,
        centerx:116.297611,
        centery:40.047363,
        tareaValue:'1212',
        width: 40,
        height: 40,
        fit: 'fill',
        preview: false,
        autoRotate: false,
        rotateDuration: 2,
        bgColor: 'rgba(0,0,0,0)',
        trackAni:false,
    },
    cptDataForm: {//动态数据配置
        dataSource: 1, //默认数据源1:静态数据，2:api接口,3:SQL,4:数据集,5:websocket
        pollTime: 0,//默认轮询时间
        dataText: '[{"LNG": "116.297611","LAT": "40.047363","URL": ""},{"LNG": "116.302839","LAT": "40.048219","URL": ""},{"LNG": "116.308301","LAT": "40.050566","URL": ""},{"LNG": "116.305732","LAT": "40.054957","URL": ""},{"LNG": "116.304754","LAT": "40.057953","URL": ""},{"LNG": "116.306487","LAT": "40.058312","URL": ""},{"LNG": "116.307223","LAT": "40.056379","URL": ""}]',//静态数据，必须为JSON格式
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
}


